import React, {useState} from "react";

export default function RNAnalysisQuestions({config,value = {},onChange,mode,feedback}) {
  const [focused,setFocused] = useState(false);
  if (!config.keyIdentification && !config.cadenceQuestions?.length) return null;
  value = value && typeof value === "object" ? value : {};
  const locked = mode === "review";
  const update = patch => onChange?.({...value,...patch});
  const border = id => {
    const part=feedback?.parts?.[id];
    return mode === "review" && typeof part?.correct === "boolean"
      ? `2px solid ${part.correct ? "#2e7d32" : "#b91c1c"}` : "1px solid #687387";
  };
  const inputStyle = id => ({fontSize:16,padding:"7px 8px",border:border(id),borderRadius:4,color:"#111",background:"white"});
  return <div style={{display:"flex",alignItems:"center",flexWrap:"wrap",gap:locked ? "20px 32px" : "48px 32px",margin:"14px 0 8px",paddingBottom:locked ? 0 : 38,color:"#111"}}>
    {config.keyIdentification && <div style={{display:"flex",alignItems:"center",gap:8}}>
      <span>Key of</span>
      <div style={{position:"relative"}}>
        <input aria-label="Key name" value={value.keyName || ""} readOnly={locked}
          onFocus={()=>setFocused(true)} onBlur={()=>setFocused(false)}
          onChange={e=>update({keyName:e.target.value})}
          autoComplete="off" autoCapitalize="off" spellCheck={false}
          style={{...inputStyle("keyName"),width:58}} />
        {focused && !locked && <div style={{position:"absolute",top:"100%",left:0,display:"flex",gap:4,zIndex:5,background:"white"}}>
          {["♭","♯"].map(acc=><button type="button" key={acc} aria-label={`Insert ${acc}`} onMouseDown={e=>e.preventDefault()}
            onClick={()=>update({keyName:(value.keyName || "")+acc})}>{acc}</button>)}
        </div>}
      </div>
      <select aria-label="Key mode" value={value.keyMode || ""} disabled={locked}
        onChange={e=>update({keyMode:e.target.value})} style={inputStyle("keyMode")}>
        <option value="">Mode…</option><option value="major">Major</option><option value="minor">minor</option>
      </select>
    </div>}
    {(config.cadenceQuestions || []).map(q=><label key={q.id} style={{display:"flex",alignItems:"center",gap:8}}>
      <span>{q.label || `${q.id} cadence:`}</span>
      <input aria-label={`${q.id} cadence`} value={value.cadences?.[q.id] || ""} readOnly={locked}
        onChange={e=>update({cadences:{...value.cadences,[q.id]:e.target.value}})}
        autoComplete="off" spellCheck={false}
        style={{...inputStyle(`cadence-${q.id}`),width:210}} />
    </label>)}
  </div>;
}
